import { HttpApi } from "@effect/platform";
import { AiAgentGroup } from "./ai-agent";
import { AttachmentGroup } from "./attachment";
import { ChatWidgetGroup } from "./chat-widget";
import { ConversationGroup } from "./conversation";
import { ConversationCountsGroup } from "./conversation-counts";
import { HealthGroup } from "./health";
import { IntegrationGroup } from "./integration";
import { MacroGroup } from "./macro";
import { MeGroup } from "./me";
import { StreamGroup } from "./stream";
import { TagGroup } from "./tag";
import { TeamNotificationGroup } from "./team-notification";
import { UserGroupGroup } from "./user-group";
import { ViewFolderGroup } from "./view-folder";
import { WebhookGroup } from "./webhook";

export class Api extends HttpApi.make("effect-api")
  .add(HealthGroup)
  .add(MeGroup)
  .add(ConversationGroup)
  .add(ConversationCountsGroup)
  .add(IntegrationGroup)
  .add(WebhookGroup)
  .add(AttachmentGroup)
  .add(TeamNotificationGroup)
  .add(StreamGroup)
  .add(AiAgentGroup)
  .add(MacroGroup)
  .add(TagGroup)
  .add(UserGroupGroup)
  .add(ViewFolderGroup)
  .add(ChatWidgetGroup) {}
